import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3jrwkg3xqx: FaireBrandEntity = {
  token: "b_3jrwkg3xqx",
  type: "brand",
  name: "The Classy Cloth WS",
  avatarUrl:
    "https://cdn.faire.com/fastly/a99ae9377635ba5737959cbe0f333f349a93549a217e7a707afad8bf66e95046.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/487a705e0f54420357eba51b135e8a0145d96f3440daadd237d74178c5f8ce87.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a99ae9377635ba5737959cbe0f333f349a93549a217e7a707afad8bf66e95046.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/487a705e0f54420357eba51b135e8a0145d96f3440daadd237d74178c5f8ce87.jpeg",
  location: "Schoolcraft, MI, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 721,
  isTopShop: true,
  isInsider: true,
  description:
    "We provide our customers high quality products with access to professional non-watermarked images. As a boutique owner for 5 years, the owner of The Classy Cloth has a unique perspective that is applied to every product designed. We value transparent communication, timely fulfillment of orders, and sourcing true home run products that sell fast for our customers!\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:46.657Z",
    importedBy: "entity-db-cli",
  },
};
